var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"clockyme-button clockyme-button__text",class:[
    {'short-size': _vm.short},
    {'small-size': _vm.small} ],attrs:{"depressed":"","outlined":"","ripple":false}},'v-btn',_vm.$attrs,false),_vm.$listeners),[(!_vm.loading)?_vm._t("default"):_vm._e(),(_vm.loading)?_c('dot-loader',{attrs:{"blue":_vm.blueLoader}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }